import { StyleSheet } from 'react-native';

import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        marginTop: 16,
        width: isTabletOrWeb ? widthPercentageToDP(480) : '100%',
    },
    description: {
        lineHeight: 24,
    },
});

export default styles;
